import { defineMessages } from 'react-intl';

export const scope = 'app.component.base.user_details';

export default defineMessages({
  no_user: {
    id: `${scope}.no_user`,
    defaultMessage: '-',
  },
});
